import {AppStore} from "../../desktop";
import {Notification} from "../../models/Notification";
import {NotificationsActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionNotificationFetchAll = () => {
	AppStore.dispatch({type: NotificationsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionNotificationFetchAllCompleted = (notifications: Notification[]) => {
	AppStore.dispatch({type: NotificationsActionTypes.FETCH_ALL_COMPLETED, payload: notifications})
}

export const actionNotificationFetch = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.FETCH_ONE_REQUEST, payload: notification})
}

export const actionNotificationFetchCompleted = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.FETCH_ONE_COMPLETED, payload: notification})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: notification})
}

export const actionNotificationSave = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.SAVE_REQUEST, payload: notification})
}

export const actionNotificationSaveCompleted = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.SAVE_COMPLETED, payload: notification})
}

export const actionNotificationDelete = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.DELETE_REQUEST, payload: notification})
}

export const actionNotificationDeleteCompleted = (notification: Notification) => {
	AppStore.dispatch({type: NotificationsActionTypes.DELETE_COMPLETED, payload: notification})
}

export const actionDeleteNotifications = (notifications: Notification[]) => {
	AppStore.dispatch({type: NotificationsActionTypes.DELETE_MULTIPLE_REQUEST, payload: notifications})
}

export const actionDeleteNotificationsCompleted = (notifications: Notification[]) => {
	AppStore.dispatch({type: NotificationsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: notifications})
}

export const actionNotificationMarkSeen = (id: string) => {
	AppStore.dispatch({type: NotificationsActionTypes.MARKSEEN_REQUEST, payload: id})
}
